<template>
    <div class="u-flex-y u-flex-items-center video_center">
   <!--   <Nav></Nav>
      <div style="height: 80px"></div> -->
        <centerHeader></centerHeader>
        <div class="u-flex u-flex-between" style="max-width: 1200px;width: 100%;margin-top: 20px;">
            <keep-alive v-if="isRouterAlive">
               <centerAside :Key='routerindex'  @stachange = 'stachange'></centerAside>
            </keep-alive>
            <div class="u-flex-y">
              <!-- 创作者中心 -->
              <transition  v-if="pagestatus == '/centerContent'" name="el-fade-in">
                  <centerContent></centerContent>
              </transition>
              <!-- 上传视频 -->
              <transition  v-if="pagestatus == '/centeraddVideo'" name="el-fade-in">
                <keep-alive v-if="isRouterAlive">
                   <centeraddVideo  @stachange = 'stachange'></centeraddVideo>
                </keep-alive>
              </transition>
              <!-- 视频管理 -->
              <transition  v-if="pagestatus == '/videomanagement'" name="el-fade-in">
                  <videomanagement @editvideo = 'editvideo'></videomanagement>
              </transition>
              <!-- 草稿 -->
              <transition v-else-if="pagestatus == '/centerfraft'" name="el-fade-in-linear">
                  <centerfraft @stachange = 'stachange' @editvideo = 'editvideo'></centerfraft>
              </transition>
              <!-- 评论 -->
               <transition v-else-if="pagestatus == '/contentreview'" name="el-fade-in-linear">
                     <contentreview></contentreview>
               </transition>
            </div>

        </div>

    </div>
</template>
<script>
    import centerHeader from '@/pages/template/centerHeader'
    import centerAside from '@/pages/template/centerAside'
    import centerContent from '@/pages/template/centerContent'
    import videomanagement from '@/pages/template/videomanagement'
    import centerfraft from '@/pages/template/centerfraft'
    import centeraddVideo from '@/pages/template/centeraddVideo'
    import contentreview from '@/pages/template/contentreview'
    import Nav from '@/component/Nav'
    export default {
        components:{
            centerHeader,
            centerAside,
            centerContent,
            centeraddVideo,
            videomanagement,
            centerfraft,
            Nav,
            contentreview
        },
        provide(){
          return {
           reload:this.reload()
          }
        },
        created(params) {
         console.log('aaaaa',this.$route.query);
           let {pagestatus} = this.$route.query;
           if(pagestatus){
             this.pagestatus = pagestatus
           }
        },
        watch:{
          $route(to,from){
            console.log(to.query);
            let {pagestatus} = to.query
              if(pagestatus =='/'){
                this.$router.replace('/')
                return
              }
              if(pagestatus){
                this.reload()
                this.pagestatus = pagestatus
              }
          }
        },
        data(){
            return {
                pagestatus:'/contentreview',
                isRouterAlive:true,
                routerindex:1,
            }
        },
        methods:{
          editvideo(val){
            this.stachange({
              path:'/centeraddVideo',
              query:{id: '10', tab: '0', statusvideo:'edit',videoId:val,pagestatus: '/centeraddVideo'}
            })
          },
          reload(){
            console.log("刷新加载！");
            this.isRouterAlive = false;
            this.$nextTick(()=>{
              this.isRouterAlive = true
            })
          },
          // 路由切换
          stachange(val){
              let {path,query} = val;
              query.pagestatus=path;
              this.$router.push({
                path:'centervideo',
                query
              });
          },
        }
    }
</script>
<style lang="scss">
  /*每个页面公共css */
  .myfontwidth1 {
    overflow: hidden; //隐藏文字
    text-overflow: ellipsis; //显示 ...
    white-space: nowrap; //不换
  }
  .myfontwidth2 {
     display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
     -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
     -webkit-line-clamp: 2; /* 2行，只有 webkit内核支持 */
     word-break: break-all; /* 纯英文换行 */
     overflow: hidden;
  }
    @import '../../assets/style/flex.scss';
    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      //background-color: #8c8c8c;
      background-color: rgba(0, 0, 0, 0.25);
    }

    ::-webkit-scrollbar-track {
      background-color: #f6f6f6;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-track {
      border: 0;
    }

    .video_center{
      background: #F7F8FA;
      min-height:98vh;
    }
</style>



// WEBPACK FOOTER //
// src/pages/mine/video.vue